import React from 'react'
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Loader, Copy } from '@elparking/components'

import connectUrl from 'commons/js/components/connectUrl'
import { ChargingPointsContainer } from '../../container'
import ChargingPoints from '../../container/ChargingPointsContainer/ChargingPoints'

function buildWithDefaultParams (params, defaultParams) {
    const allParams = {}
    if (!params['place_id']) {
        allParams['place_id'] = defaultParams['place_id']
    } else {
        allParams['place_id'] = params['place_id']
    }
    return new URLSearchParams(allParams)
}

function areParamsPresent (params) {
    return params['place_id']
}

class LocationDetector extends React.PureComponent {
    static propTypes = {
        component: PropTypes.elementType,
        geocodePlace: PropTypes.func,
        defaultParams: PropTypes.shape({
            place_id: PropTypes.string,
        }),
        search: PropTypes.shape({
            place_id: PropTypes.string,
            latitude: PropTypes.number,
            longitude: PropTypes.number,
        }),
        // From Router
        location: PropTypes.object,
        history: PropTypes.object,
        match: PropTypes.object,
        // From connectUrl,
        push: PropTypes.func,
    }

    static defaultProps = {
        component: ChargingPointsContainer,
    }

    constructor (props) {
        super(props)
        this.state = {
            placeId: props.search['place_id'],
        }
        this.setPlaceIdBasedOnAvailableParams = this.setPlaceIdBasedOnAvailableParams.bind(this)
    }

    setDefaultPlaceId () {
        this.setState({placeId: this.props.defaultParams['place_id']})
    }

    async findPlaceIdByLatitudeLongitude (latLong) {
        let geoResult
        try {
            geoResult = await this.props.geocodePlace(latLong)
        } catch (e) {
            this.setDefaultPlaceId()
        }
        if (geoResult) {
            this.setState({ placeId: geoResult['place_id'] })
        } else {
            this.setDefaultPlaceId()
        }
    }

    setPlaceIdBasedOnAvailableParams (latitude, longitude) {
        if (latitude && longitude) {
            const latLng = {latitude, longitude}
            this.findPlaceIdByLatitudeLongitude(latLng)
        } else {
            this.setDefaultPlaceId()
        }
    }

    componentDidMount () {
        if (!this.state.placeId) {
            const { latitude, longitude } = this.props.search
            this.setPlaceIdBasedOnAvailableParams(latitude, longitude)
        }
    }

    renderLoader () {
        return (
            <Copy align='center' padding='20px'>
                <Loader size='20px' />
            </Copy>
        )
    }

    render () {
        const {location, search, component: ChargingPointsContainer, defaultParams} = this.props
        const {placeId} = this.state
        let params = { ...search }

        if (!placeId) {
            return this.renderLoader()
        }

        params['place_id'] = placeId
        delete params['latitude']
        delete params['longitude']

        const mySearch = `?${buildWithDefaultParams(params, defaultParams)}`

        if (!areParamsPresent(search)) {
            return (
                <Redirect
                  to={{
                      pathname: location.pathname,
                      search: mySearch,
                      state: {
                          from: location,
                      },
                  }}
                />
            )
        }
        return (
            <ChargingPointsContainer
              location={this.props.location}
              match={this.props.match}
              history={this.props.history}
              placeId={search.place_id}
              push={this.props.push}
            >
                {(props) => <ChargingPoints {...props} />}
            </ChargingPointsContainer>
        )
    }
}

function mapParamsToProps (_, searchParams) {
    return {
        search: {
            ...searchParams,
            place_id: searchParams['place_id'],
            latitude: searchParams.latitude ? parseFloat(searchParams.latitude) : null,
            longitude: searchParams.longitude ? parseFloat(searchParams.longitude) : null,
        },
    }
}

export default connectUrl(mapParamsToProps)(LocationDetector)
